import * as React from 'react'
import AppView from '@app'
import { createRoot } from 'react-dom/client'

const container = document.getElementById('react-redux-app')
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const root = createRoot(container!)
root.render(<AppView />)
